import { render, staticRenderFns } from "./QRClass.vue?vue&type=template&id=c40bc0de"
import script from "./QRClass.vue?vue&type=script&lang=js"
export * from "./QRClass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports